import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { DataTable, ButtonIcon, Button, Popover, Dropdown, DateRangePicker, Search, Icon, Notification, Breadcrumb, Badge, Modal } from "pepsico-ds";
import { useEffect, useRef, useState } from "react";
import "./entra-guest.css"
import { useLoading } from "../../loader";
import entraGuestService from "./entra-guest.service";
import { toast, ToastContainer } from 'react-toastify';

const GuestManagement = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const { showLoader, hideLoader } = useLoading();
    const [loader, setLoader] = useState(false);
    const [toggleFilter, setToggleFilter] = useState(false);
    const [selectedRows, setSelectedRows] = useState([])
    const [searchInput, setSearchInput] = useState("")
    const [selectedStatusFilter, setSelectedStatusFilter] = useState([{ id: '1', displayText: t("auditRequest.audit_all"), value: '' }]);
    const [selectedInvitationStatusFilter, setSelectedInvitationStatusFilter] = useState([{ id: '1', displayText: t("auditRequest.audit_all"), value: '' }]);
    const [selectedStatusFilterAfterApply, setSelectedStatusFilterAfterApply] = useState([{ id: '1', displayText: t("auditRequest.audit_all"), value: 'ALL' }]);
    const [selectedInvitationStatusFilterAfterApply, setSelectedInvitationStatusFilterAfterApply] = useState([{ id: '1', displayText: t("auditRequest.audit_all"), value: 'ALL' }]);
    const [selectedRangeAfterApply, setSelectedRangeAfterApply] = useState({
        from: null,
        to: null,
    });
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(0)
    const [selectedRange, setSelectedRange] = useState({
        from: null,
        to: null,
    });
    const [guestList, setGuestList] = useState([]);
    const guestListRef = useRef(null);
    const isRtl = i18n.language?.split("_")?.[0] === "ar";

    function camelToTitle(str) {
        if (str.includes("_")) {
            return str
                .toLowerCase()
                .split("_")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
        }
        return str
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    }

    const [showRevokeModel, setShowRevokeModel] = useState(false);
    const [revokeRequestNumber, setRevokeRequestNumber] = useState(null);
    const [revokeGuestEmail, setRevokeGuestEmail] = useState(null);

    const handleRevokeModel = () => {
        setShowRevokeModel(true);
    }

    const revokeHandler = async(requestNumber, guestEmail) => {
        showLoader();
        setLoader(true);
        try{
            const payload = {
                requestNumber,
                guestEmail
            };
            const response = await entraGuestService.revokeAccess(payload);
            if(response?.status=== "Success"){
                toast.success(response?.message,"success");
                fetchViewRequests(currentPage);
            }else{
                toast.error(response?.message || response?.errorMessage,"error");
                hideLoader();
                setLoader(false);
            }
        }catch(e){
            hideLoader();
            setLoader(false);
            toast.error(t('nonArExtension.error_api'),"error");
        }
    }

    const handleRefresh = async(requestNumber, guestEmail) => {
        showLoader();
        setLoader(true);
        try{
            const payload = {
                requestNumber,
                guestEmail
            };
            const response = await entraGuestService.refreshUserData(payload);
            if(response?.status && response?.requestNumber){
                const updatedGuestList = guestListRef?.current?.map((rec)=> (rec?.guestEmail === guestEmail  && rec?.requestNumber === requestNumber) ? {...rec,...response}: rec);
                setGuestList(updatedGuestList);
                guestListRef.current = updatedGuestList;
                if(response?.isUserDisabled){
                    const updatedGuestList = guestListRef?.current?.filter((rec)=> !(rec?.guestEmail === guestEmail  && rec?.requestNumber === requestNumber));
                    setTimeout(()=>{
                        setGuestList(updatedGuestList);
                        guestListRef.current = updatedGuestList;
                    },5000)
                    toast.error(t('entraGuest.guest_management_refresh_user_disable_error_msg'),"error");
                }else{
                    toast.success(response?.message,"success");
                }
            }else{
                toast.error(response?.message || response?.errorMessage,"error");
            }
            hideLoader();
            setLoader(false);
        }catch(e){
            hideLoader();
            setLoader(false);
            toast.error(t('nonArExtension.error_api'),"error");
        }
    }

    const sendReminderHandler = async(requestNumber, guestEmail) => {
        showLoader();
        setLoader(true);
        try{
            const payload = {
                requestNumber,
                guestEmail
            };
            const response = await entraGuestService.resendInvite(payload);
            if(response?.status=== "Success"){
                toast.success(response?.message,"success");
                fetchViewRequests(currentPage);
            }else{
                toast.error(response?.message || response?.errorMessage,"error");
                hideLoader();
                setLoader(false);
            }
        }catch(e){
            hideLoader();
            setLoader(false);
            toast.error(t('nonArExtension.error_api'),"error");
        }
    }

    const resetMFAHandler = async(requestNumber, guestEmail) => {
        showLoader();
        setLoader(true);
        try{
            const payload = {
                requestNumber,
                guestEmail
            };
            const response = await entraGuestService.resetMfa(payload);
            if(response?.status=== "Success"){
                toast.success(response?.message,"success");
                fetchViewRequests(currentPage);
            }else{
                toast.error(response?.message || response?.errorMessage,"error");
                hideLoader();
                setLoader(false);
            }
        }catch(e){
            hideLoader();
            setLoader(false);
            toast.error(e?.response?.data?.message || e?.response?.data?.errorMessage || t('nonArExtension.error_api'),"error");
        }
    }

    const columns= [
        // { columnKey: "companyName", header: t("entraGuest.table_company"), showColumnVisibility: true, initialSize: 120 },
        { columnKey: "guestName", header: t("entraGuest.table_guest_name"), initialSize: 165 },
        { columnKey: "guestEmail", header: t("entraGuest.table_guest_email"), initialSize: 200 },
        // { columnKey: "domain", header: t("entraGuest.table_domain"), initialSize: 185, cellData: (ctx) => {
        //         return <div className="ad-account-environment">
        //             {ctx.row.original?.domain}
        //         </div>
        //     } 
        // },
        { columnKey: "approver", header: t("entraGuest.table_approver"), initialSize: 170 },
        { columnKey: "status", header: t("entraGuest.table_status"), initialSize: 170,  cellData: (ctx) => {
                return <div className={`guest-status-${ctx.row.original?.status === "APPROVED" ? "approved" : ctx.row.original?.status === "IN_PROGRESS" ? "in-progress" : ctx.row.original?.status === "REJECTED" ? "rejected" : ctx.row.original?.status === "FAILED" ? "failed" : "cancelled" }`}>
                    {camelToTitle(ctx.row.original?.status)}
                </div>
            } 
        },
        { columnKey: "invitationStatus", header: t("entraGuest.table_invitation_status"), initialSize: 175, cellData: (ctx) => {
                return <div className={`guest-invitation-status-${ctx.row.original?.invitationStatus === "SEPENDING_ACCEPTANCENT" ? "sent" : ctx.row.original?.invitationStatus === "NOT_SENT" ? "not-sent" : ctx.row.original?.invitationStatus === "ACCEPTED" ? "accepted" : "na" }`}>
                    <Icon
                        alt="alt value"
                        icon={`${ctx.row.original?.invitationStatus === "PENDING_ACCEPTANCE" ? "close" : ctx.row.original?.invitationStatus === "NOT_SENT" ? "access_time" : ctx.row.original?.invitationStatus === "ACCEPTED" ? "check" : "" }`}
                        size="18px"
                        style={{}}
                    />
                    {camelToTitle(ctx.row.original?.invitationStatus)}
                </div>
            }  },
        { columnKey: "requestedOnDate", header: t("entraGuest.table_requested_on"), initialSize: 170,  cellData: (ctx) => {
                return <div>
                    {ctx.row.original?.requestedOnDate?.split?.(".")?.[0]}
                </div>
            } 
        },
        { columnKey: "lastLogOn", header: t("entraGuest.table_last_logged_in"), initialSize: 170 },
        { columnKey: "", header: t("entraGuest.table_action"), initialSize: 165, enableSorting: false,  cellData: (ctx) => {
                return <div className="selected-rows-action-btn d-flex" style={{gap: ".5rem"}}>
                            {ctx.row.original?.enableRevokeAccess && <Button
                                className="revoke-access-btn"
                                iconLeading="cancel"
                                loadingText=""
                                size="small"
                                style={{border: "none"}}
                                text={t("entraGuest.revoke_access")}
                                variant="secondary"
                                onClick={(e)=>{
                                    e.stopPropagation();
                                    setRevokeRequestNumber(ctx.row.original?.requestNumber);
                                    setRevokeGuestEmail(ctx.row.original?.guestEmail);
                                    handleRevokeModel();
                                }}
                            />}
                            {ctx.row.original?.enableSendReminder && <Button
                                className="send-reminder-btn"
                                iconLeading="mail"
                                loadingText=""
                                size="small"
                                style={{border: "none"}}
                                text={t("entraGuest.send_reminder")}
                                variant="secondary"
                                onClick={(e)=>{
                                    e.stopPropagation()
                                    sendReminderHandler(ctx.row.original?.requestNumber, ctx.row.original?.guestEmail)
                                }}
                            />}
                            {ctx.row.original?.enableResetMfa && <Button
                                className="send-reminder-btn"
                                iconLeading="undo"
                                loadingText=""
                                size="small"
                                style={{border: "none"}}
                                text={t("entraGuest.reset_mfa")}
                                variant="secondary"
                                onClick={(e)=>{
                                    e.stopPropagation()
                                    resetMFAHandler(ctx.row.original?.requestNumber, ctx.row.original?.guestEmail)
                                }}
                            />}
                            {ctx.row.original?.refreshEnabled && <Icon
                                alt="alt value"
                                className={"$color-icon-default request-refresh-btn " + (isRtl ? "ml-2" : "mr-2")}
                                icon="refresh"
                                data-tooltip-id="refresh-tooltip" data-tooltip-content="Refresh"
                                size="small"
                                onClick={() => handleRefresh(ctx.row.original?.requestNumber, ctx.row.original?.guestEmail)}
                                style={{ alignItems: 'center', cursor: 'pointer', maxHeight: "25px", maxWidth: "25px" }}
                            />}
                        </div>
            } 
        },
    ];

    const statusOptions = [
        { id: '1', displayText: t("auditRequest.audit_all"), value: '' },
        { id: '2', displayText: t("entraGuest.in_progress"), value: 'IN_PROGRESS' },
        { id: '3', displayText: t("entraGuest.approved"), value: 'APPROVED' },
        { id: '4', displayText: t("entraGuest.rejected"), value: 'REJECTED' },
        { id: '5', displayText: t("entraGuest.cancelled"), value: 'CANCELLED' },
        { id: '6', displayText: t("entraGuest.failed"), value: 'FAILED' },
    ];

    const invitationStatusOptions = [
        { id: '1', displayText: t("auditRequest.audit_all"), value: '' },
        { id: '2', displayText: t("entraGuest.not_sent"), value: 'NOT_SENT' },
        { id: '3', displayText: t("entraGuest.pending_acceptance"), value: 'PENDING_ACCEPTANCE' },
        { id: '4', displayText: t("entraGuest.accepted"), value: 'ACCEPTED' },
        { id: '5', displayText: t("entraGuest.na"), value: 'NA' }
    ];

    const handleDateRangeChange = (range) => {
        setSelectedRange(range);
    };

    const handleApplyFilter = () => {
        setToggleFilter(false)
        fetchViewRequests(currentPage)
        setSelectedStatusFilterAfterApply([...selectedStatusFilter]?.map((x)=>({...x, ...(!x.value && {value: 'ALL'} )})))
        setSelectedInvitationStatusFilterAfterApply([...selectedInvitationStatusFilter]?.map((x)=>({...x, ...(!x.value && {value: 'ALL'} )})))
        setSelectedRangeAfterApply({...selectedRange})
    }

    const resetFilter = () => {
        setSelectedStatusFilter(null);
        setSelectedInvitationStatusFilter(null);
        setSelectedRange({
            from: null,
            to: null,
        })
    }

    const formatDate = (dateString) => {
        if (!dateString) return null;
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const fetchViewRequests = async(page, isClear=false) => {
        showLoader();
        setLoader(true);
        try{
            const payload = {
                pagination: {
                    page: page || 0,
                    pageSize: 10
                },
                search: {
                    guestNameSearch: isClear ? "" : searchInput?.trim?.() || "",
                },
                filter: {
                    status: selectedStatusFilter?.[0]?.value || "",
                    invitationStatus: selectedInvitationStatusFilter?.[0]?.value || "",
                    dateFilter: {
                        startDate: (selectedRange?.from && selectedRange?.to) ? formatDate(selectedRange?.from) : "",
                        endDate: (selectedRange?.from && selectedRange?.to) ? formatDate(selectedRange?.to) : ""
                    }
                }
            };
            const response = await entraGuestService.viewRequests(payload);
            if(response?.requestDetails?.length>0){
                setGuestList(response?.requestDetails);
                guestListRef.current = response?.requestDetails;
                setTotalRecords(response?.totalRecords)
            }else{
                setGuestList([]);
                guestListRef.current = [];
                setTotalRecords(0);
            }
            hideLoader();
            setLoader(false);
        }catch(e){
            hideLoader();
            setLoader(false);
            setGuestList([]);
            guestListRef.current = [];
        }
    }

    useEffect(()=>{
        fetchViewRequests(0);
    },[]);

    return (
        <>
            <div className="entra-guest-main-container">
                <div
                    className={isMobile ? "row" : "container"}
                    style={{
                        background: "none",
                        boxShadow: "none",
                        justifyContent: isMobile ? "center" : "",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            flexDirection: isMobile ? "column" : "row",
                            gap: isMobile ? "0px" : "15px",
                            flexWrap: "wrap",
                            flex: 1,
                        }}
                    >
                        <div className={isMobile ? "row mt-2" : ""} style={{ justifyContent: isMobile ? "center" : "" }}>
                            <div className="d-flex align-items-center justify-content-between" style={{flexWrap: "wrap"}}>
                                {/* <div className={`${isMobile ? 'pl-4 pr-4 ml-4 mr-4' : 'd-flex'}  align-items-center ad-main-heading-container my-2`} style={{ gap: "12px" }}>
                                    <ButtonIcon
                                        className=""
                                        color="Interaction/Active"
                                        icon="arrow_backward"
                                        label="Label"
                                        onClick={() => navigate(-1)}
                                        size="medium"
                                        style={{}}
                                        type="default"
                                    />
                                    <div className="ad-main-heading" style={{whiteSpace: "nowrap"}}>{t("entraGuest.m365_guest_management")}</div>
                                </div> */}
                                  <div
                                    className={`${isMobile ? 'pl-4 pr-4 ml-4 mr-4' : ''} ad-main-heading-container my-2`}
                                >
                                    <Breadcrumb
                                        homeIcon={{
                                            icon: "home",
                                            onClick:()=>{
                                            navigate("/home")
                                            }
                                        }}
                                        breadcrumbs={[
                                            {
                                                label: "Home",
                                            },
                                            {
                                                label: "Guest Management",
                                            },
                                        ]}
                                        className="entra-breadcrumb"
                                        useAnchor
                                    />

                                    <div className="ad-page-header">
                                        <div
                                            className="ad-main-heading"
                                            style={{ whiteSpace: "nowrap" }}
                                        >
                                            {t("entraGuest.m365_guest_management")}
                                        </div>
                                    </div>
                                </div>
                                <div className="guest-management-notification d-flex">
                                    <Icon
                                        alt="alt value"
                                        icon="info"
                                        size="small"
                                        style={{}}
                                    />
                                    <div>
                                        <strong>{t("entraGuest.invitation_status")}</strong> {t("entraGuest.and")} <strong>{t("entraGuest.last_logged_in")}</strong> {t("entraGuest.rest_info_msg")}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="card-layout reg-card mb-3 mb-md-0 active-directory-card-container entra-guest-container"
                                style={{
                                    flex: isMobile ? "unset" : "0 0 calc(66.666% - 7.5px)",
                                    width: isMobile ? "100%" : "auto",
                                    flexDirection: isMobile ? "column" : "row",
                                    gap: "1rem"
                                }}
                            >
                                <div className="card card-content align-items-center m-0 mb-3">
                                    <div className="guest-management-table-header d-flex justify-content-between">
                                        <div className="d-flex">
                                            <div
                                                style={{
                                                    alignItems: 'center',
                                                    display: 'flex',
                                                    position: 'relative'
                                                }}
                                                >
                                                <Button
                                                    onClick={()=>setToggleFilter((prev)=>!prev)}
                                                    text={t("auditRequest.filter")}
                                                    variant="secondary"
                                                    className="filter-btn togglt-filter m-0"
                                                    size="small"
                                                    iconLeading="filter_alt"
                                                    style={{paddingRight: "2rem"}}
                                                />
                                                <Badge
                                                    className="m-0"
                                                    type="important"
                                                    value={[!!selectedStatusFilter?.length,!!selectedInvitationStatusFilter?.length,selectedRange?.from && selectedRange?.to]?.filter(Boolean)?.length}
                                                />
                                                <div
                                                    style={{
                                                    padding: '15px 0',
                                                    position: 'absolute',
                                                    top: '90%',
                                                    ...(isRtl ? {right: '240%'} : {left: '195%'})
                                                    }}
                                                    className="popover-container"
                                                >
                                                    <Popover
                                                    badgeValue=""
                                                    className=""
                                                    direction="top-left"
                                                    onClosePopover={()=>setToggleFilter(false)}
                                                    showSlot
                                                    showPopover={toggleFilter}
                                                    style={{}}
                                                    text={t("auditRequest.filter")}
                                                    >
                                                        <Dropdown
                                                            childList={statusOptions}
                                                            label={t("auditRequest.status")}
                                                            placeholder={t("RequestGPIDForNonEmployee.select_btn_label")}
                                                            isClearable={false}
                                                            selection="single"
                                                            size="medium"
                                                            setSelectedValue={(selected) => setSelectedStatusFilter(selected)}
                                                            selectedValue={selectedStatusFilter}
                                                            onKeyDown={(e) => e.preventDefault()}
                                                            showLabelIcon={false}
                                                            style={{gap: ".5rem", marginBottom: ".5rem"}}
                                                        />
                                                        <Dropdown
                                                            childList={invitationStatusOptions}
                                                            label={t("entraGuest.invitation_status")}
                                                            placeholder={t("RequestGPIDForNonEmployee.select_btn_label")}
                                                            isClearable={false}
                                                            selection="single"
                                                            size="medium"
                                                            setSelectedValue={(selected) => setSelectedInvitationStatusFilter(selected)}
                                                            selectedValue={selectedInvitationStatusFilter}
                                                            onKeyDown={(e) => e.preventDefault()}
                                                            showLabelIcon={false}
                                                            style={{gap: ".5rem", marginBottom: ".5rem"}}
                                                        />
                                                        <DateRangePicker
                                                            label={t("entraGuest.requested_on")}
                                                            style={{width: '100%'}}
                                                            datePickerMenu={{ 
                                                                firstDayOfWeek: "sunday",
                                                                disabled:{
                                                                    afterDate: new Date()
                                                                }
                                                            }}
                                                            endYear={2030}
                                                            onSelectDateRange={handleDateRangeChange}
                                                            placeholder={t("entraGuest.date_filter")}
                                                            selectedDateRange={selectedRange}
                                                            size="small"
                                                            startYear={1950}
                                                            showClearIcon={selectedRange?.from && selectedRange?.to}
                                                        />
                                                        <div className="d-flex justify-content-between mt-3">
                                                            <div style={{
                                                                fontSize: "12px",
                                                                fontWeight: "500",
                                                                display: "flex",
                                                                alignItems: "center"
                                                                }}>{`${[!!selectedStatusFilter?.length,!!selectedInvitationStatusFilter?.length,selectedRange?.from && selectedRange?.to]?.filter(Boolean)?.length} ${t("auditRequest.filter_selected")}`}</div>
                                                            <div className="d-flex" style={{gap: ".5rem"}}>
                                                                <Button
                                                                    onClick={()=>setToggleFilter(false)}
                                                                    text={t("auditRequest.cancel_label")}
                                                                    variant="tertiary"
                                                                    className="filter-btn"
                                                                    size="small"
                                                                    style={{fontWeight: "bold"}}
                                                                />
                                                                <Button
                                                                    onClick={handleApplyFilter}
                                                                    text={t("auditRequest.apply_filter")}
                                                                    variant="primary"
                                                                    className="filter-btn"
                                                                    size="small"
                                                                    disabled={!(selectedStatusFilter?.length || selectedInvitationStatusFilter?.length || (selectedRange?.from && selectedRange?.to) )}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Popover>
                                                </div>
                                            </div>
                                            <div className="selected-filters d-flex mx-1">
                                                {selectedStatusFilterAfterApply?.[0]?.value && <div className="accountsAlign">
                                                    <span className="endPointInfo mr-1" style={{fontSize: "9px"}}>{camelToTitle(selectedStatusFilterAfterApply?.[0]?.displayText)}</span>
                                                </div>}
                                                {selectedInvitationStatusFilterAfterApply?.[0]?.value && <div className="accountsAlign">
                                                    <span className="endPointInfo mr-1" style={{fontSize: "9px"}}>{camelToTitle(selectedInvitationStatusFilterAfterApply?.[0]?.displayText)}</span>
                                                </div>}
                                                {selectedRangeAfterApply?.from && selectedRangeAfterApply?.to && <div className="accountsAlign">
                                                    <span className="endPointInfo mr-1" style={{fontSize: "9px"}}>{`${formatDate(selectedRangeAfterApply?.from)} - ${formatDate(selectedRangeAfterApply?.to)}`}</span>
                                                </div>}
                                            </div>
                                        </div>
                                        <div className="search-guest-record d-flex">
                                            <Search
                                                isClearable={searchInput.length>0}
                                                menuPosition="bottom-right"
                                                onClear={() => fetchViewRequests(currentPage, true)}
                                                onSearch={() => fetchViewRequests(currentPage)}
                                                onSelectOption={function oFe() { }}
                                                onUpdate={(e) =>{
                                                    setSearchInput(e);
                                                    if(!e)fetchViewRequests(currentPage, true);
                                                }}
                                                delay={0}
                                                placeholderText={t("entraGuest.search_filter_placeholder")}
                                                size="medium"
                                                style={{maxWidth:"revert", minWidth: "17rem"}}
                                                value={searchInput}
                                            />
                                        </div>
                                    </div>
                                    {/* {
                                        selectedRows.length>0 ?
                                    <div className="guest-management-selected-row-section d-flex justify-content-between">
                                        <div className="selected-rows-container d-flex justify-content-between w-100">
                                            <span  class="font font-typography $color-text-primary $font-small-bold">
                                                {selectedRows?.length === guestList?.length ? t("entraGuest.all_rows_selected") : `${selectedRows?.length} ${t("entraGuest.of")} ${guestList?.length} ${t("entraGuest.rows_selected")}`}
                                            </span>
                                            <div className="selected-rows-action-btn d-flex" style={{gap: ".5rem"}}>
                                                <Button
                                                    className="revoke-access-btn"
                                                    iconLeading="cancel"
                                                    loadingText=""
                                                    size="small"
                                                    style={{}}
                                                    text={t("entraGuest.revoke_access")}
                                                    variant="secondary"
                                                />
                                                <Button
                                                    className="send-reminder-btn"
                                                    iconLeading="mail"
                                                    loadingText=""
                                                    size="small"
                                                    style={{}}
                                                    text={t("entraGuest.send_reminder")}
                                                    variant="secondary"
                                                />
                                            </div>
                                        </div>
                                    </div>:
                                    null
                                    } */}
                                    <div className="guest-management-table hide-rows-per-page">
                                        <DataTable
                                            className="datatable"
                                            columns={columns}
                                            key={i18n.language}
                                            rowKey="id"
                                            // initialRowSelection={selectedRows}
                                            totalRowsCount={totalRecords}
                                            // rowSelectionStateUpdater={(selection) => setSelectedRows(selection)}
                                            enableSorting={true}
                                            data={guestList}
                                            pageIndex={currentPage}
                                            pageSize={10}
                                            // selection="multiple"
                                            tableHeader="Data table header"
                                            size="large"
                                            showTableHeader={true}
                                            showTitle={true}
                                            showSearchOption={false}
                                            showColumnFilters={false}
                                            showDescription={false}
                                            tableDescription=""
                                            showPagination={true}
                                            noDataDescriptionText=""
                                            manualPagination={true}
                                            onPageIndexChange={(page)=>
                                                {
                                                    setCurrentPage(page-1)
                                                    fetchViewRequests(page-1)
                                                }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                showRevokeModel && <Modal
                    className="remind-approve-modal"
                    closeOnOutsideClick
                    onCloseModal={() => {
                        setShowRevokeModel(false);
                    }}
                    primaryButtonProps={{
                        size: "medium",
                        text: t("approvals.revoke"),
                        variant: "primary",
                        onClick: () => {
                            setShowRevokeModel(false);
                            revokeHandler(revokeRequestNumber, revokeGuestEmail)
                        },
                    }}
                    secondaryButtonProps={{
                        size: "medium",
                        text: t("auditRequest.cancel_label"),
                        variant: "secondary",
                        onClick: () => {
                            setShowRevokeModel(false);
                        },
                    }}
                    showTertiaryButton={false}
                    showAuxiliaryButton={false}
                    showLink={false}
                    showModal={showRevokeModel}
                    style={{}}
                    text={t("entraGuest.revoke_confirmation_msg")}
                    title={t("entraGuest.revoke_access")}
                    type="fluid"
                    viewPort={isMobile ? "mobile" : "desktop"}
    
                />
            }
            <ToastContainer
                position="bottom-center"
            />
        </>
    )
}

export default GuestManagement